import React, { FC, forwardRef } from 'react';

import { ButtonProps, Checkbox, Loader, UnstyledButton } from '@mantine/core';

import cx from './styles.module.scss';

const SimpleButton: FC<
    {
        onClick?: (event: React.MouseEvent) => void;
        disabled?: boolean;
        children: React.ReactNode;
        variant?: 'light' | 'dark';
        checkbox?: boolean;
        checked?: boolean;
        loading?: boolean;
        fullWidth?: boolean;
        onMouseEnter?: () => void;
        onMouseLeave?: () => void;
        href?: string;
        target?: React.HTMLAttributeAnchorTarget;
        rel?: string;
    } & ButtonProps
> = forwardRef(
    (
        { onClick, children, variant = 'light', loading, fullWidth, checkbox, checked, disabled, href, ...props },
        ref,
    ) => (
        <UnstyledButton
            {...props}
            className={[
                cx.button,
                variant === 'dark' && cx.dark,
                loading && cx.loading,
                fullWidth && cx.fullWidth,
                props.className,
            ]
                .filter(Boolean)
                .join(' ')}
            onClick={onClick}
            loading={loading}
            disabled={disabled}
            data-disabled={disabled}
            /* @ts-ignore */
            ref={ref}
            href={href}
            component={href ? 'a' : 'button'}
        >
            <span className={cx.content}>
                {checkbox !== undefined && <Checkbox size="xs" checked={checked} />}
                {children}
            </span>
            {loading && <Loader size={10} className={cx.loader} />}
        </UnstyledButton>
    ),
);

SimpleButton.displayName = 'SimpleButton';

export { SimpleButton };
